/**
 * Main App component with routing and providers
 */

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { WagmiProvider } from 'wagmi'
import { mainnet } from 'wagmi/chains'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RainbowKitProvider } from '@rainbow-me/rainbowkit'
import { Toaster } from 'react-hot-toast'
import { HelmetProvider } from 'react-helmet-async'

import { rainbowKitConfig, rainbowKitTheme, appInfo } from './config/rainbowkit'
import { Layout } from './components/layout/Layout'

// Pages
import { HomePage } from './pages/HomePage'
import { DashboardPage } from './pages/DashboardPage'
import { VaultsPage } from './pages/VaultsPage'
import { LOCsPage } from './pages/LOCsPage'
import { LoansPage } from './pages/LoansPage'
import { AboutPage } from './pages/AboutPage'
import { DebugPage } from './pages/DebugPage'
import { BankDashboardPage } from './pages/BankDashboardPage'
import PartnerBankPage from './pages/PartnerBankPage'

// Styles
import '@rainbow-me/rainbowkit/styles.css'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

function App() {
  return (
    <HelmetProvider>
      <WagmiProvider config={rainbowKitConfig}>
        <QueryClientProvider client={queryClient}>
          <RainbowKitProvider 
            theme={rainbowKitTheme}
            appInfo={appInfo}
            modalSize="compact"
            showRecentTransactions={true}
            initialChain={mainnet}
          >
            <Router>
              <Layout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/dashboard" element={<DashboardPage />} />
                  <Route path="/vaults" element={<VaultsPage />} />
                  <Route path="/locs" element={<LOCsPage />} />
                  <Route path="/loans" element={<LoansPage />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/debug" element={<DebugPage />} />
                  <Route path="/partner-bank/:slug" element={<PartnerBankPage />} />
                  <Route path="/bank-dashboard" element={<BankDashboardPage />} />
                </Routes>
              </Layout>
              
              {/* Toast notifications */}
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#fff',
                    color: '#374151',
                  },
                  success: {
                    iconTheme: {
                      primary: '#FF6B35',
                      secondary: '#fff',
                    },
                  },
                }}
              />
            </Router>
          </RainbowKitProvider>
        </QueryClientProvider>
      </WagmiProvider>
    </HelmetProvider>
  )
}

export default App

